export const useEmptyTestAgentView = () => {
  const sampleQuestions = [
    'What is the pricing?',
    'Share your product catalog',
    'How deep is your dealer and distributor network?',
    'Do you have any offers, schemes or loyalty programs?',
  ];

  return {
    sampleQuestions,
  };
};
